import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from './PluginGeneratedSerialDescriptor.mjs';
import { contentEqualsaf55p28mnw74 as contentEquals } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from './PluginHelperInterfaces.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var InlineClassDescriptorClass;
function InlineClassDescriptor() {
  if (InlineClassDescriptorClass === VOID) {
    class $ extends PluginGeneratedSerialDescriptor() {
      constructor(name, generatedSerializer) {
        super(name, generatedSerializer, 1);
        this.p1b_1 = true;
      }
      t11() {
        return this.p1b_1;
      }
      hashCode() {
        return imul(super.hashCode(), 31);
      }
      equals(other) {
        var tmp$ret$0;
        $l$block_5: {
          // Inline function 'kotlinx.serialization.internal.equalsImpl' call
          if (this === other) {
            tmp$ret$0 = true;
            break $l$block_5;
          }
          if (!(other instanceof InlineClassDescriptor())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.h10() === other.h10())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(other.p1b_1 && contentEquals(this.z1a(), other.z1a()))) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.u11() === other.u11())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          var inductionVariable = 0;
          var last = this.u11();
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (!(this.y11(index).h10() === other.y11(index).h10())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
              if (!equals(this.y11(index).s11(), other.y11(index).s11())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
            }
             while (inductionVariable < last);
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, 'InlineClassDescriptor');
    InlineClassDescriptorClass = $;
  }
  return InlineClassDescriptorClass;
}
function InlinePrimitiveDescriptor(name, primitiveSerializer) {
  return new (InlineClassDescriptor())(name, new (InlinePrimitiveDescriptor$1())(primitiveSerializer));
}
var InlinePrimitiveDescriptor$1Class;
function InlinePrimitiveDescriptor$1() {
  if (InlinePrimitiveDescriptor$1Class === VOID) {
    class $ {
      constructor($primitiveSerializer) {
        this.q1b_1 = $primitiveSerializer;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.q1b_1];
      }
      az() {
        var message = 'unsupported';
        throw IllegalStateException().o4(toString(message));
      }
      oz(encoder, value) {
        // Inline function 'kotlin.error' call
        var message = 'unsupported';
        throw IllegalStateException().o4(toString(message));
      }
      pz(decoder) {
        // Inline function 'kotlin.error' call
        var message = 'unsupported';
        throw IllegalStateException().o4(toString(message));
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForClass($, VOID, VOID, VOID, [GeneratedSerializer()]);
    InlinePrimitiveDescriptor$1Class = $;
  }
  return InlinePrimitiveDescriptor$1Class;
}
//region block: exports
export {
  InlineClassDescriptor as InlineClassDescriptor2odlvyasjrmr0,
  InlinePrimitiveDescriptor as InlinePrimitiveDescriptor3i6ccn1a4fw94,
};
//endregion

//# sourceMappingURL=InlineClassDescriptor.mjs.map
